import { signIn } from './fetchApi'
import { tokenStorage, userStorage, newPracticeStorage } from './localStorage'

const authManager = {
  isAuthenticated: !!tokenStorage.get(),

  authenticate(user) {
    return signIn(user)
      .then((res) => {
        tokenStorage.set(res.token)
        userStorage.set(JSON.stringify(res.roles))
        this.isAuthenticated = true
        return Promise.resolve(true)
      })
  },

  signout() {
    tokenStorage.clear()
    newPracticeStorage.clear()
    userStorage.clear()
    this.isAuthenticated = false
  },
}

export default authManager



// WEBPACK FOOTER //
// ./src/services/auth.js